import {COMMON_STYLES} from '../../constants/styles';

export const requestStatusesStyles = {
  ...COMMON_STYLES,
  header: {
    gap: 2,
  },
  typeButtons: {
    ml: 'auto',
  },
};
